import React, { FC } from "react";
import { ArrowForwardRounded } from "@mui/icons-material";
import { uiContainerTransitionMs } from "@src/utils";
import { Box } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

export const navArrowHoverStyles = {
  ".nav-arrow-forward": {
    opacity: 1,
    transform: `translate3d(0px, 0, 0)`,
  },
};

interface Props {}

export const Arrow: FC<Props> = ({}) => {
  return (
    <Box
      component="span"
      sx={{
        overflow: "visible",
        width: "1px",
        display: "inline-block",
      }}
    >
      <ArrowForwardRounded
        className="nav-arrow-forward"
        sx={{
          width: "12px",
          height: "12px",
          color: Colors.HeadingText,
          stroke: Colors.HeadingText,
          strokeWidth: "0.5px",
          opacity: 0,
          transform: `translate3d(-5px, 0, 0)`,
          transition: `transform ${uiContainerTransitionMs}ms ease-in-out, opacity ${uiContainerTransitionMs}ms ease-in-out`,
        }}
      />
    </Box>
  );
};
